import { render } from "./CreateL2NetworkForm.vue?vue&type=template&id=ba013aee&scoped=true"
import script from "./CreateL2NetworkForm.vue?vue&type=script&lang=js"
export * from "./CreateL2NetworkForm.vue?vue&type=script&lang=js"

import "./CreateL2NetworkForm.vue?vue&type=style&index=0&id=ba013aee&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba013aee"]])

export default __exports__